var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 40,
    viewBox: "0 0 132 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visa-black ",
    clipPath: "url(#clip0_309_12276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1",
    filter: "url(#filter0_d_309_12276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M46.7284 39.4275L53.331 0.674098H63.8982L57.2883 39.4275H46.7284ZM95.5923 1.63079C92.5584 0.531684 89.3536 -0.0204488 86.1268 6.29014e-05C75.6902 6.29014e-05 68.341 5.25464 68.2758 12.785C68.2178 18.3512 73.5231 21.4822 77.5311 23.3159C81.539 25.1495 83.0248 26.4251 83.0031 28.1211C83.0031 30.7158 79.7199 31.9044 76.6831 31.9044C73.2512 32.0092 69.842 31.3145 66.7248 29.875L65.3622 29.259L63.9127 37.9562C66.3769 39.0361 70.9429 39.9783 75.6757 40.0218C86.7791 40.0218 93.9833 34.8252 94.0703 26.7803C94.1065 22.3737 91.2944 19.018 85.1991 16.2494C81.5101 14.4592 79.2488 13.2633 79.2705 11.4442C79.2705 9.83518 81.1839 8.11023 85.3223 8.11023C88.0302 8.03843 90.7233 8.53212 93.2296 9.55977L94.179 10.0091L95.6286 1.60905L95.5923 1.63079ZM122.677 0.724832H114.516C111.987 0.724832 110.095 1.4496 108.986 3.93556L93.302 39.4492H104.413C104.413 39.4492 106.225 34.673 106.638 33.6511H120.162C120.481 35.0064 121.445 39.4492 121.445 39.4492H131.229L122.677 0.724832ZM109.631 25.7004C110.53 23.4536 113.835 14.8578 113.835 14.8578C113.835 14.8578 114.704 12.611 115.234 11.1615L116.009 14.4954L118.452 25.6859L109.631 25.7004ZM37.8717 0.724832L27.5293 27.1282L26.4276 21.7431C24.4997 15.5536 18.5059 8.84225 11.8018 5.48656L21.2238 39.3768H32.3997L49.0621 0.724832H37.8717Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.9406 0.681396H0.908489L0.770782 1.44965C14.0196 4.68937 22.7893 12.4444 26.4276 21.7432L22.724 3.9501C22.0862 1.49314 20.2308 0.761121 17.9333 0.681396",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_309_12276",
    x: -3.22922,
    y: -0.000488281,
    width: 138.458,
    height: 48.0222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_309_12276"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_309_12276",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_309_12276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130.458,
    height: 40,
    fill: "white",
    transform: "translate(0.770782)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.546da8c378e0b76d8225483300441eba.svg";
export { ForwardRef as ReactComponent };